import { Injectable } from '@angular/core'
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { OktaState } from 'app/okta/okta-state'
import { OktaService } from 'app/okta/okta.service'
import { CookieService } from 'app/shared/cookie.service'
import { HybridService } from 'app/shared/hybrid/hybrid.service'
import { Observable, zip } from 'rxjs'
import { UserDetailsService } from '../user-details.service'

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private cookieService: CookieService,
        private hybridService: HybridService,
        private oktaService: OktaService,
        private userDetailsService: UserDetailsService,
        private oktaState: OktaState
    ) { }

    canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return new Observable<boolean>(obs => {
            zip(this.userDetailsService.getUserDetails(), this.userDetailsService.isOktaInUse())
                .subscribe(([userDetails, oktaAktivatedFromOrca]) => {
                    let oktaInUse = this.OktaActivated(this.oktaService.oktaInUse(), oktaAktivatedFromOrca)
                    if (oktaInUse) {
                        if (!userDetails.isAuthenticated) {
                            this.oktaState.isLoaded$.subscribe(val => {
                                if (val) this.oktaService.onOktaSubmitted.emit(true)
                            })
                        }
                        obs.next(true)
                    }
                    else {
                        if (!userDetails.isAuthenticated) {
                            this.cookieService.deleteCookie(this.cookieService.sbwAuthType)
                            localStorage.removeItem('sbw_Token')
                            this.hybridService.forceLogin(state.url)
                            obs.next(false)
                        } else {
                            obs.next(true)
                        }
                    }
                    if (userDetails.isAuthenticated && userDetails.isAgent) {
                        obs.next(true)
                    }
                })
        })
    }

    private OktaActivated(oktaSetWithCookie: boolean, oktaSetFromOrca: boolean): boolean {
        if (oktaSetWithCookie) return true
        if (oktaSetFromOrca) return true
        return false
    }
}
